import { render, staticRenderFns } from "./TitlePond.vue?vue&type=template&id=6c5a88c2"
import script from "./TitlePond.vue?vue&type=script&lang=js"
export * from "./TitlePond.vue?vue&type=script&lang=js"
import style0 from "./TitlePond.vue?vue&type=style&index=0&id=6c5a88c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports